import {
  FETCH_SUPPORT_BADGE,
  FETCH_SUPPORT_BADGE_SUCCESS,
  FETCH_MY_SUPPORT_BADGE,
  FETCH_MY_SUPPORT_BADGE_SUCCESS,
  CLEAR_SUPPORT_BADGE,
} from "./actionTypes"

const initialState = {
  // Personel yanıtı bekleyen talep sayısı — sunucudan gelir, istemcide hesaplanmaz.
  awaitingReplyCount: 0,
  // Destek Yönetimi (personel) özet kartlarının diğer üç sayacı. Aynı uçtan (admin summary)
  // geldikleri için burada tutulurlar; ekran ikinci bir istek atmaz, rozetle birlikte tazelenir.
  totalCount: 0,
  answeredCount: 0,
  closedCount: 0,
  // Kullanıcının kendi taleplerinden personelce yanıtlanmış olanların sayısı
  awaitingMyReplyCount: 0,
  loading: false,
}

const supportBadge = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SUPPORT_BADGE:
    case FETCH_MY_SUPPORT_BADGE:
      return { ...state, loading: true }

    case FETCH_SUPPORT_BADGE_SUCCESS:
      return {
        ...state,
        loading: false,
        awaitingReplyCount: action.payload?.awaitingReplyCount || 0,
        totalCount: action.payload?.totalCount || 0,
        answeredCount: action.payload?.answeredCount || 0,
        closedCount: action.payload?.closedCount || 0,
      }

    case FETCH_MY_SUPPORT_BADGE_SUCCESS:
      return {
        ...state,
        loading: false,
        awaitingMyReplyCount: action.payload?.awaitingMyReplyCount || 0,
      }

    case CLEAR_SUPPORT_BADGE:
      return { ...initialState }

    default:
      return state
  }
}

export default supportBadge
